<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <section class="landing-course-preview-section">
    <b-container class="landing-course-preview-wrapper">
      <h4 class="title">What do you want to learn today?</h4>
      <div class="tab-wrapper">
        <div class="tab-controls">
          <div class="tab-lg-controls">
            <b-tabs content-class="mt-3">
              <!-- <b-tab title="First" active><p></p></b-tab> -->
              <category-tabs
                :tabTitle="tabPopular"
                :isActive="active"
                :is-a-category="!active"
              />
              <!--<category-tabs-->
              <!--:tabTitle="tabRe"-->
              <!--:isActive="active"-->
              <!--:is-a-category="!active"-->
              <!--/>-->
              <category-tabs
                v-for="(category) in categoryData"
                :key="category.category_id"
                :tabTitle="category.name"
                :isActive="active"
                :is-a-category="active"
                :categoryId="category.category_id"
              />
              <!--More button only when exceded that col-->
              <b-tab class="p-0">
                <template slot="title" v-if="hiddenCategoryData.length > 0">
                  <b-link
                    class="moredrop"
                  >
                    <b-dropdown id="dropdown-1" no-caret right>
                      <template v-slot:button-content>
                        <font-awesome-icon
                          icon="ellipsis-h"
                        ></font-awesome-icon>
                      </template>
                      <b-dropdown-item  v-for="(category, i) in hiddenCategoryData" :key="i"
                                        @click.prevent.stop="openTabDropdown(category,i)">{{ category.name}}</b-dropdown-item>
                    </b-dropdown>
                  </b-link>
                </template>
                <p>More</p>
              </b-tab>
            </b-tabs>
          </div>
          <!-- <div class="more-selection">
            <font-awesome-icon icon="ellipsis-h"></font-awesome-icon>
					</div>-->
        </div>
      </div>
      <div class="rich-text">
        <p>
          Enroll, Learn, Grow, Repeat!
          <br />Get ready to achive your learning goals
        </p>
        <b-button size="lg" pill variant="primary" @click="goToAllCourses">
          <span>Get started</span>
          <font-awesome-icon icon="arrow-right" size="xs" />
        </b-button>
      </div>
    </b-container>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CategoryTabs from "../Templates/categoryTabs";

export default {
  name: "Landing_course_preview",
  components: {
    CategoryTabs
  },
  data() {
    return {
      active: true,
      categoryData: [],
      hiddenCategoryData: [],
      tabPopular: "Most Popular",
      tabRe: "Recommended",
      tabLength: 7,
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        items: 4,
        gutter: 20,
        swipeAngle: 45,
        controls: true,
        autoInit: true,
        responsive: {
          640: {
            edgePadding: 20,
            items: 3
          },
          1200: {
            items: 4
          }
        }
      },
      courseData: Array,
      count: 0
    };
  },
  computed: {
    ...mapGetters("category", ["getCategoryData"])
  },
  methods: {
    goToAllCourses() {
      this.$router.push({
        path: "/all_courses"
      });
    },
    responsiveness() {
      if (screen.width > 1200) {
        this.tabLength = 4;
      } else if (screen.width > 992) {
        this.tabLength = 3;
      } else if (screen.width > 768) {
        this.tabLength = 2;
      } else {
        this.tabLength = 1;
      }
    },
    openTabDropdown(category,i) {
        this.categoryData.push(category);
        this.hiddenCategoryData.splice(i,1);
        this.hiddenCategoryData.push(this.categoryData[0]);
        this.categoryData.splice(0,1);
    },
      setCategoryArray(){
        this.getCategoryData.forEach( (category,i) => {
           if(i <= this.tabLength) this.categoryData.push(category);
           else this.hiddenCategoryData.push(category);
        });
      }
  },
  beforeMount() {
    this.responsiveness();
    let self = this;
    window.onresize = function(event) {
      self.responsiveness();
    };
  },
    mounted(){
      this.setCategoryArray();
    },
};
</script>

<style lang="sass">
@import '../../../node_modules/tiny-slider/src/tiny-slider.scss'
</style>
